module.exports = "/_next/static/images/led-retrofit-projects-da375c6723e7ed2e91109f4c9509faff.webp";